import React, { useState } from 'react';
import './AjaxComponents.css';
import { useTranslation } from 'react-i18next';
import { Colors, Images } from '../../themes';
import { ReactComponent as NightModeOn } from '../../images/ajax/night_mode_on.svg';
import { ReactComponent as NightModeOff } from '../../images/ajax/night_mode_off.svg';
import clsx from 'clsx';
import { Table, TableBody, TableRow, TableCell, ButtonBase, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import './AjaxComponents.css';

const useStyles = makeStyles((theme) => {
  return {
    DetailsWidget: {
      display: 'flex',
      flexDirection: 'column',
      overflowWrap: 'break-word',
    },
    tableCellButton: {
      padding: '11px 0 11px 20px',
      width: '100%',
      fontSize: 16,
      [theme.breakpoints.down(420)]: {
        paddingLeft: '10px ',
      },
    },
    tableBodyCellButton: {
      justifyContent: 'flex-start',
      textAlign: 'left',
    },
    activeRow: {
      '& .MuiTableCell-body, & .MuiInputBase-input': {
        color: Colors.blue,
      },
      '&:nth-child(n)': {
        backgroundColor: Colors.white,
      },
    },
    nameCell: {
      width: '60%',
      [theme.breakpoints.down(420)]: {
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
    },
    commandButtonCell: {
      width: 200,
      [theme.breakpoints.down(420)]: {
        // minWidth: 150,
        // maxWidth: 150,
        // width: 150,
      },
      paddingHorizontal: 0,
    },
    noDataCell: {
      padding: '10px 20px',
    },
    noSortLabel: {
      color: Colors.lightGrey,
      padding: '11px 20px',
    },
    button: {
      fontSize: 14,
      color: Colors.white,
      border: `1px solid ${Colors.white}`,
      '&:hover:not(.Mui-disabled)': {
        background: Colors.disabledGrey,
        color: Colors.white,
      },
    },
    activeRowButton: {
      color: Colors.black,
      border: `1px solid ${Colors.disabledGrey}`,
    },
    armingButton: {
      margin: 10,
      [theme.breakpoints.down(420)]: {
        width: 167,
      },
    },
    errorButton: {
      color: Colors.errorRed,
      borderColor: Colors.errorRed,
      '&:hover': {
        borderColor: Colors.disabledGrey,
      },
    },
    errorText: {
      color: Colors.errorRed,
      fontSize: '0.75rem',
      marginTop: 4,
    },
  };
});

const HubsTable = (props) => {
  const { t } = useTranslation();
  const hubStates = [
    { name: 'DISARMED', display: t('ajax.disarmed'), isNightMode: false, isArmed: false },
    { name: 'ARMED', display: t('ajax.armed'), isNightMode: false, isArmed: true },
    { name: 'NIGHT_MODE', display: 'NIGHT MODE', isNightMode: true, isArmed: true },
    { name: 'ARMED_NIGHT_MODE_ON', display: t('ajax.armed'), isNightMode: true, isArmed: true },
    { name: 'ARMED_NIGHT_MODE_OFF', display: t('ajax.armed'), isNightMode: false, isArmed: true },
    { name: 'DISARMED_NIGHT_MODE_ON', display: t('ajax.disarmed'), isNightMode: true, isArmed: false },
    { name: 'DISARMED_NIGHT_MODE_OFF', display: t('ajax.disarmed'), isNightMode: false, isArmed: false },
    { name: 'PARTIALLY_ARMED_NIGHT_MODE_ON', display: t('ajax.partiallyArmed'), isNightMode: true, isArmed: true },
    { name: 'PARTIALLY_ARMED_NIGHT_MODE_OFF', display: t('ajax.partiallyArmed'), isNightMode: false, isArmed: true },
  ];
  const { data, handleSelectRow, activeRowField, activeRowValue, onButtonClick, isLoading, isGroups } = props;
  const noDataText = t('ajax.noHubs');
  const classes = useStyles();
  const columns = [
    { title: 'Hub name', field: 'name' },
    { title: 'command', field: 'state' },
    { title: 'nightMode', field: 'nightMode' },
  ];
  const [hubArmingId, setHubArmingId] = useState(null);
  const [groupArmingId, setGroupArmingId] = useState(null);

  const handleHubButtonClick = (groupsEnabled, stateName, isArmed, hubId) => {
    let command = '';
    if (!groupsEnabled) {
      switch (stateName) {
        case 'ARMED':
          command = 'NIGHT_MODE_ON';
          break;
        case 'NIGHT_MODE':
          command = 'DISARM';
          break;
        case 'DISARMED':
          command = 'ARM';
          break;
      }
    } else if (groupsEnabled) {
      command = isArmed ? 'DISARM' : 'ARM';
    }
    setHubArmingId(hubId);
    onButtonClick(command, hubId);
  };
  const handleGroupButtonClick = (isArmed, hubId, hubIndex, groupId) => {
    setGroupArmingId(groupId);
    onButtonClick(isArmed, hubId, hubIndex, groupId);
  };

  return (
    <Table>
      <TableBody>
        {data && data.length > 0 ? (
          data.map((row, index) => {
            const hubState = hubStates.find((state) => state.name === row.state);
            const { groupsEnabled } = row;
            const { name: stateName, display, isNightMode, isArmed } = hubState || {};
            return (
              <TableRow
                key={index}
                className={clsx(
                  'hubTableRow',
                  activeRowField && activeRowValue && row[activeRowField] === activeRowValue && classes.activeRow
                )}
              >
                {columns.map((column) => {
                  return (
                    <TableCell
                      key={column.field + index}
                      className={clsx(
                        column.field === 'name'
                          ? classes.nameCell
                          : column.field === 'state'
                          ? classes.commandButtonCell
                          : null
                      )}
                    >
                      {column.field === 'state' ? (
                        <Button
                          disabled={isLoading}
                          type="button"
                          variant="outlined"
                          className={clsx(
                            classes.button,
                            activeRowField &&
                              activeRowValue &&
                              row[activeRowField] === activeRowValue &&
                              classes.activeRowButton,
                            classes.armingButton,
                            isArmed ? 'hubNotArmedButton' : display ? classes.errorButton : null,
                            'ajax_hub_button'
                          )}
                          onClick={() => {
                            isGroups
                              ? handleGroupButtonClick(isArmed, row.hubId, row.hubIndex, row.id)
                              : handleHubButtonClick(groupsEnabled, stateName, isArmed, row.hubId);
                          }}
                          {...(!isLoading &&
                            display && {
                              endIcon: <span className={`status_dot ${isArmed ? 'button_on' : 'button_off'}`}></span>,
                            })}
                        >
                          {(isLoading &&
                            ((!isGroups && (!hubArmingId || hubArmingId === row.hubId)) ||
                              (isGroups && (!groupArmingId || groupArmingId === row.id)))) ||
                          !display
                            ? 'loading...'
                            : display
                            ? display
                            : ''}
                        </Button>
                      ) : column.field === 'nightMode' ? (
                        <div className="ajax_hub_nightmode_container">
                          {!isGroups ? (
                            isNightMode ? (
                              <NightModeOn />
                            ) : (
                              <NightModeOff />
                            )
                          ) : (
                            <div className="ajax_hub_empty_nightmode_placeholder" />
                          )}
                        </div>
                      ) : (
                        <ButtonBase
                          disabled={isGroups}
                          className={clsx(classes.tableCellButton, classes.tableBodyCellButton)}
                          {...(handleSelectRow && { onClick: (event) => handleSelectRow(row.hubId) })}
                          centerRipple
                        >
                          <div className="ajax_group_name_container">
                            {row[column.field]}
                            {isGroups && (
                              <div className={'ajax_device_room_name ajax_group_hub_name'}>{row.hubName}</div>
                            )}
                          </div>
                        </ButtonBase>
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })
        ) : (
          <TableRow>
            <TableCell className={classes.noDataCell} colSpan={columns.length}>
              {isLoading ? 'loading...' : noDataText}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default HubsTable;
